import { Hero } from "../components/sections/Hero";
import { TrustBar } from "../components/sections/TrustBar";
import { About } from "../components/sections/About";
import { Diagnostics } from "../components/sections/Diagnostics";
import { Services } from "../components/sections/Services";
import { WhyChooseUs } from "../components/sections/WhyChooseUs";
import { ServiceArea } from "../components/sections/ServiceArea";
import { Crew } from "../components/sections/Crew";
import { Testimonials } from "../components/sections/Testimonials";
import { ContactForm } from "../components/sections/ContactForm";
import { useReveal } from "../hooks/use-reveal";
import { useSeo } from "../hooks/use-seo";
import { localBusinessJsonLd, SITE_BASE_URL } from "../lib/jsonld";

export default function Home() {
    useReveal();
    useSeo({
        title:
            "HAZ Insulation | Spray Foam, Attic & Crawl Space Experts · Chicagoland & NW Indiana",
        description:
            "Chicagoland's full-envelope insulation crew — spray foam, blown-in cellulose, attic systems, crawl space encapsulation, dense pack, and air sealing. NICOR & ComEd rebate partner with 50+ five-star reviews. Free quote in 48 hours.",
        canonical: `${SITE_BASE_URL}/`,
        jsonLd: localBusinessJsonLd({ url: `${SITE_BASE_URL}/`, withRating: true }),
    });
    return (
        <main data-testid="home-page">
            <Hero />
            <TrustBar />
            <About />
            <Diagnostics />
            <Services />
            <WhyChooseUs />
            <Crew />
            <ServiceArea />
            <Testimonials />
            <ContactForm />
        </main>
    );
}
